module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_category_trading_card_e1b3a03c2eceb26011715e39f978ebae.png";